import { render } from "./GlobalPresenceCompMod.vue?vue&type=template&id=48452308"
import script from "./GlobalPresenceCompMod.vue?vue&type=script&lang=js"
export * from "./GlobalPresenceCompMod.vue?vue&type=script&lang=js"

import "./GlobalPresenceCompMod.vue?vue&type=style&index=0&id=48452308&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__